import { useState } from 'react';
import { Badge, Button, Group, Space, Tooltip } from '@mantine/core';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';

import CustomDataTable from '../../components/custom_data_table';
import { QueryDocumentSnapshot } from 'firebase/firestore';
import { KCCUploads } from '../../types';
import { httpsCallable } from 'firebase/functions';
import { useFunctions } from '../../helpers/firebaseContext';

const DownloadKccReplyButton = ({ fileName }: { fileName?: string }) => {
    const functions = useFunctions();
    const downloadKccReplyFile = httpsCallable<{ fileName: string }, { fileName: string; contentBase64: string }>(functions, "downloadKccReplyFile");
    const [busy, setBusy] = useState(false);

    if (!fileName) {
        return <Tooltip label="No KCC response received yet"><span>-</span></Tooltip>;
    }

    const download = async () => {
        setBusy(true);
        try {
            const result = await downloadKccReplyFile({ fileName });
            const bytes = Uint8Array.from(atob(result.data.contentBase64), (c) => c.charCodeAt(0));
            const blob = new Blob([bytes], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = result.data.fileName || fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (e: any) {
            console.error("Failed to download KCC reply file", e);
            notifications.show({ title: "KCC response download failed", message: e?.message || "Check console", color: "red" });
        } finally {
            setBusy(false);
        }
    };

    return (
        <Tooltip label={fileName}>
            <Button color="blue" loading={busy} onClick={download}>
                Download
            </Button>
        </Tooltip>
    );
};

const KCCModalButton = () => {
    const functions = useFunctions();
    const sendSubAccountNumbersToKCC = httpsCallable(functions, "sendSubAccountNumbersToKCC");
    const importCustomerResponsesFromSFTP = httpsCallable(functions, "importCustomerResponsesFromSFTP");
    return (
        <Button


            onClick={
                () => {
                    modals.open({
                        // keep the modal inside the viewport; the table below scrolls horizontally
                        size: '95vw',
                        title: "KCC",
                        children: <>
                            <div>


                                <Group justify="end">

                                    <Button
                                        color="green"

                                        onClick={() => {
                                            sendSubAccountNumbersToKCC();
                                        }}
                                    >
                                        Manually Send Sub-Account Numbers Request
                                    </Button>

                                    <Button
                                        color="violet"

                                        onClick={() => {
                                            importCustomerResponsesFromSFTP();
                                        }}
                                    >
                                        Manually Get KCC Response
                                    </Button>

                                </Group>
                            </div>
                            <Space h="sm" />
                            <div style={{ overflowX: 'auto', maxWidth: '100%' }}>


                                <CustomDataTable
                                    orderByAttribute="createdAt"
                                    orderDirection="desc"
                                    tableKey={"kcc_uploads"}

                                    // title="KCC Uploads"
                                    columns={[
                                        {
                                            name: "Name",
                                            selector: (row: QueryDocumentSnapshot<KCCUploads>) => row.id,
                                            // grow: true
                                            wrap: true
                                        },
                                        {
                                            name: "Created ",
                                            selector: (row: QueryDocumentSnapshot<KCCUploads>) => {

                                                if (row.data().createdAt) {
                                                    let createdbyUser = "Created By " + row.data().createdBy?.token?.email;
                                                    return <Tooltip label={createdbyUser}><span>{row.data()?.createdAt?.toDate().toLocaleString("en-gb")}</span></Tooltip>
                                                } else {
                                                    return "-"
                                                }
                                            },
                                            wrap: true

                                        },
                                        {
                                            name: "status",
                                            selector: (row: QueryDocumentSnapshot<KCCUploads>) => row.data().status,
                                            format: (row: QueryDocumentSnapshot<KCCUploads>) => <Badge color={row.data().status === "done" ? "green" : row.data().status === "failed" ? "red" : "orange"} >{row.data().status}</Badge>,
                                            grow: true

                                        },
                                        {
                                            name: "Total",
                                            selector: (row: QueryDocumentSnapshot<KCCUploads>) => (row.data().total || 0),
                                            grow: true
                                            ,
                                        }
                                        ,
                                        {
                                            name: "Completed",
                                            selector: (row: QueryDocumentSnapshot<KCCUploads>) => (row.data().completed || 0),
                                            grow: true

                                        }
                                        ,
                                        {
                                            name: "Response File",
                                            selector: (row: QueryDocumentSnapshot<KCCUploads>) => <DownloadKccReplyButton fileName={row.data().lastReplyFile} />,
                                            grow: true
                                        },
                                        {
                                            name: "Refetch Document",
                                            selector: (row: QueryDocumentSnapshot<KCCUploads>) => <>
                                                <Button
                                                    color="violet"

                                                    onClick={() => {
                                                        importCustomerResponsesFromSFTP({ fileID: row.data().filename });
                                                    }}
                                                >
                                                    Re-Fetch
                                                </Button>
                                            </>,
                                            grow: true

                                        }

                                    ]}


                                    paginationComponentOptions={{
                                        selectAllRowsItem: true,
                                        selectAllRowsItemText: "All",
                                    }}

                                    selectableRows={false}
                                    selectableRowsVisibleOnly={false}
                                    selectableRowsHighlight={false}

                                />
                            </div>
                        </>
                    })
                }
            }
        >
            KCC
        </Button>
    )
}

export default KCCModalButton